<mat-card-header  fxLayout="row"  style="margin-bottom:-70px;margin-left: -10px;">
    <!-- <mat-icon class="card-header-icon" mat-card-avatar><img [src]="iconpath" style="width: 55px;"/></mat-icon> -->
     <div mat-card-avatar class="custom-avatar">
    <img [src]="iconpath" width="50"/>
</div>
    <mat-card-title class="two-column-title" style="width:100%;">
        <div class="left-column">
            <ng-container *ngIf="isTransformName; else tnameTemplate">
                <input type="text" [ngClass]="['no-border']" [ngStyle]="{color: nodeColor}" (input)="TransformTextChanged()" (blur)="saveConfig()"
                [(ngModel)]="viewModel.transform.name" [disabled]="isReadOnly" appAutowidth font="20px / 20px Roboto"/><span [ngStyle]="{color: nodeColor}">{{transformNameType}}</span>
            </ng-container>
            <ng-template #tnameTemplate>
                <span [ngStyle]="{color: nodeColor}"
                    font="20px / 20px Roboto">{{nodeName}}</span><span [ngStyle]="{color: nodeColor}">{{transformNameType}}</span> 
            </ng-template>
            
        </div>
        <!-- <div class="right-column">
            <div fxFlex></div>
            <div>
                <button mat-button (click)="viewTransformConfigJson()">
                    <mat-icon class="primary-color-icon" style="margin-right: 10px;">article</mat-icon>View JSON
                </button>
                <button mat-button (click)="runTransform()" [disabled]="viewModel.isTransformRunning">
                    <mat-icon style="margin-left: 10px; margin-right: 10px;" *ngIf="viewModel.isTransformRunning">
                        <mat-spinner diameter="20" color="#ffffff"></mat-spinner>
                    </mat-icon>
                    <mat-icon class="green-icon" title="Run Pipeline" style="margin-right: 10px;">play_arrow</mat-icon>
                    RUN TRANSFORMER
                </button>
                <button mat-button (click)="saveConfig()">
                    <mat-icon class="primary-color-icon" style="margin-right: 10px;">save</mat-icon>SAVE TRANSFORMER
                </button>
                <a mat-button [href]="aboutlink" target="_blank">
                    <i class="fa-solid fa-question primary-color-icon" style="margin-right: 5px;font-weight: bold;"></i>About...
                </a>
            </div>
        </div> -->
        <div class="right-column" >
    <div class="buttons">
        <!-- Read-Only indicator: this tab doesn't hold the Edit lock for the
             refinery this node belongs to. Save/Run/Reset/Paste/Import are
             disabled below (isReadOnly on each); this makes WHY visible
             rather than leaving the Analyst to guess from greyed-out buttons. -->
        <span *ngIf="isReadOnly" matTooltipClass="custom-mat-tooltip"
              matTooltip="You can view this node's configuration and output, but changes require Edit mode."
              style="margin-right: 8px; padding: 2px 10px; border-radius: 10px; background: #5a2d2d; color: #f2c2c2; font-size: 12px; font-weight: 600; letter-spacing: .04em;">
          <mat-icon style="vertical-align: middle; font-size: 16px; height: 16px; width: 16px;">visibility</mat-icon>
          READ-ONLY
        </span>

        <!-- Compiler status indicator: grey = no compiled engine for this type (or no rules yet),
             orange = rules but not compiled, green = fully compiled, yellow = partially compiled.
             Gated on isAuditable first -- a transform type with no compiled engine at all must
             never show "Not Compiled", since saving it will never produce one. -->
        <ng-container *ngIf="isAuditable; else noCompilerIndicator">
          <span *ngIf="compiledConfigHash && hasRules && compiledConfig?.fullySupported !== false"
                class="compiler-indicator compiler-active"
                [matTooltip]="'Compiled at ' + (compiledAt | date:'MMM d, HH:mm') + ' — production runs use the fast compiled engine'">
            <mat-icon class="compiler-icon">bolt</mat-icon>Compiled
          </span>
          <span *ngIf="compiledConfigHash && hasRules && compiledConfig?.fullySupported === false"
                class="compiler-indicator compiler-partial"
                [matTooltip]="'Partially compiled — unsupported rules: ' + (compiledConfig?.unsupportedRules?.join(', ') || 'unknown') + '. Save after updating the compiler to resolve.'">
            <mat-icon class="compiler-icon">bolt</mat-icon>Partial
          </span>
          <span *ngIf="!compiledConfigHash && hasRules"
                class="compiler-indicator compiler-inactive"
                matTooltip="Save the transformer to compile it for fast production runs">
            <mat-icon class="compiler-icon">bolt</mat-icon>Not Compiled
          </span>
          <span *ngIf="!hasRules"
                class="compiler-indicator compiler-empty"
                matTooltip="Add rules to this transformer">
            <mat-icon class="compiler-icon">bolt</mat-icon>Not Configured
          </span>
        </ng-container>
        <ng-template #noCompilerIndicator>
          <span class="compiler-indicator compiler-empty"
                matTooltip="This transform type does not have a compiled fast-path engine">
            <mat-icon class="compiler-icon">bolt</mat-icon>Not Configured
          </span>
        </ng-template>

        <button mat-icon-button
                [disabled]="auditButtonState === 'disabled'"
                (click)="onAuditButtonClick()"
                [matTooltip]="auditButtonTooltip">
          <mat-icon [ngClass]="{
                       'audit-icon-green':    auditButtonState === 'green',
                       'audit-icon-red':      auditButtonState === 'red',
                       'audit-icon-blue':     auditButtonState === 'blue',
                       'audit-icon-unsaved':  auditButtonState === 'unsaved',
                       'audit-icon-disabled': auditButtonState === 'disabled'
                     }"
                    style="font-size: 20px; height: 20px; width: 20px; line-height: 20px; vertical-align: middle;">
            fact_check
          </mat-icon>
        </button>

        <button mat-button *ngIf="cacheStatus" [disabled]="cacheStatus === 'Not Cached'"
                [matTooltip]="cacheStatus === 'Not Cached' ? 'Nothing to purge — not cached' : 'Purge this transformer\'s cached output'">
            <mat-icon class="primary-color-icon" style=" margin-right: 2px;font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;" (click)="purgeCache()">
                delete_sweep
            </mat-icon>
            <span [ngClass]="{
                'cache-not':      cacheStatus === 'Not Cached',
                'cache-local':    cacheStatus === 'Local Cache',
                'cache-pipeline': cacheStatus === 'Pipeline Cache',
                'cache-both':     cacheStatus === 'Both Cache'
              }"> {{cacheStatus}} </span>
        </button>

        <!-- ALL 5 BUTTONS HERE -->
         <button
            mat-icon-button
            matTooltip="Import"
            [disabled]="isReadOnly"
            (click)="fileInput.click()">
            <mat-icon color="primary"
                style="margin-right: 2px;font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;">
                file_upload
            </mat-icon>
            </button>

            <input
                #fileInput
                type="file"
                hidden
                accept=".json"
                [disabled]="isReadOnly"
                (change)="importFile($event)">

        <button mat-icon-button (click)="importTransformer()" matTooltip="Paste Config" [disabled]="isReadOnly">
            <img src="assets/images/Paste JSON Button.png"
                alt="Paste Config Button"
                style="margin-right: 2px;font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;" />
        </button>

        <!-- <button mat-button (click)="importTransformer()">
            <mat-icon class="primary-color-icon"style=" margin-right: 2px;font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;">
                file_upload
            </mat-icon>
            Import Transformer
        </button> -->

        <button mat-button (click)="openSmartSample()" [disabled]="!inputCacheKey"
                matTooltip="Find the optimal sample range for this farm">
            <mat-icon class="primary-color-icon" style="margin-right: 2px; font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;">tune</mat-icon><span [ngClass]="{ 'cached': smartSampleIsCurrent }">Smart Sample</span>
        </button>

        <button mat-button (click)="viewTransformConfigJson()">
            <mat-icon class="primary-color-icon" style="margin-right: 2px; font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;">article</mat-icon>View Config
        </button>

        <button mat-button (click)="runTransform()" [disabled]="viewModel.isTransformRunning || isReadOnly">
            <mat-icon class="green-icon" title="Run Pipeline" style="margin-right: 2px; font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;">play_arrow</mat-icon>
            Run Transformer
        </button>

        <button mat-button (click)="saveConfig()" [disabled]="isReadOnly">
            <mat-icon class="primary-color-icon" style="margin-right: 2px; font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;">save</mat-icon>Save Transformer
        </button>

        <button mat-button (click)="resetTransform()" [disabled]="!hasResetSupport || isReadOnly"
                [matTooltip]="hasResetSupport ? 'Reset this transformer to its blank, unconfigured state' : 'Reset Transformer is not yet available for this transform type'">
            <mat-icon class="primary-color-icon" style="margin-right: 2px; font-size: 22px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;">restart_alt</mat-icon>Reset Transformer
        </button>

        <a mat-button [href]="aboutlink" target="_blank">
            <i class="fa-solid fa-question primary-color-icon" style="margin-right: 2px; font-size: 16px;height: 22px; width: 22px;line-height: 22px;vertical-align: middle;font-weight: bold;"></i>About...
        </a>
    </div>
</div>

    </mat-card-title>
    <mat-card-subtitle >
        <div class="horizontal-container">
            Refinery Name: <a [routerLink]="['/node']" [state]="{refineryConfigGuid: refineryConfigGuid}">{{refineryName}}</a>
            <ng-container *ngIf="isTransformName; else nodenameTemplate">
                Node {{nodeIndex}}: <a [routerLink]="['/dataTransformConfig/'+configGuid+'/configDetail']">{{nodeName}}</a>
            </ng-container>
            <ng-template #nodenameTemplate>
                Node {{nodeIndex}}:<span [ngStyle]="{color: nodeColor}">{{nodeName}}</span> 
            </ng-template>
            <div class="horizontal-scroll-container">
              <div class="horizontal-link-list">
                <a *ngFor="let item of transformslists; let i = index"
                    [ngStyle]="{color: item.transform.run === false ? 'orange' : ((viewModel.transform.index==item.index)? nodeColor:'')}"
                    (click)="showTransformDetail(item.guid)"
                    [attr.data-index]="item.index"
                    #transformLink>
                    {{"T"+item.index+": "+item.name}}{{item.transform.run === false ? " (disabled)" : ""}}{{transformslists.length>(i+1) ? " -->" : ""}}
                </a>
              </div>
            </div>
        </div>
    </mat-card-subtitle>
</mat-card-header>
